import type { UploadedFileData } from '../types/files';
import { tokenManager, checkRateLimit } from '../utils';

import { widgetApi } from '../../config';

export const uploadFileApi = async (file: File, folder: string): Promise<UploadedFileData> => {
  const formData = new FormData();
  formData.append('file', file);

  const token = tokenManager.getToken();

  const result = await fetch(`${widgetApi}/filestore/${folder}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  await checkRateLimit(result);

  return (await result.json()) as UploadedFileData;
};
